import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch } from 'react-redux';

import { ServiceEx } from '../../../../../../../models/ServicePresets';
import { TextButton, TextButtonClassNames } from '../../../../../../commons/buttons/TextButton';
import { ReactComponent as CheckIcon } from '../../../../../../../assets/images/ArrowSaveEmail.svg';
import { modalSlice } from '../../../../../../../store/reducers/ModalSlice';
import { ModalVariants } from '../../../../../../../models/Common';

interface WifiMonitoringExSrvProps {
  serviceEx: ServiceEx;
  isDisabled: boolean;
}

const WifiMonitoringExSrv: FC<WifiMonitoringExSrvProps> = ({ serviceEx: { IsConnected, Name, Price }, isDisabled }) => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const { openModal } = modalSlice.actions;
  const handleConnectStaticIP = () => {
    dispatch(openModal({ modalVariants: ModalVariants.GetHelp, content: { service: Name } }));
  };
  return (
    <div className="service-card__info-container__info__additional">
      <span>
        {Name}
        {IsConnected ? ` (${Price} ${t('services.uahPerMonth')})` : null}:&nbsp;
      </span>
      <div className="btn-wrap">
        <TextButton
          label={<span>{t('common.getHelp')}</span>}
          handleClick={handleConnectStaticIP}
          className={TextButtonClassNames.PrimaryActive}
          isDisabled={isDisabled}
        />
        &nbsp;&nbsp;
        <CheckIcon className="icon-check" />
      </div>
    </div>
  );
};

export default WifiMonitoringExSrv;
